<div [ngSwitch]="value">
	<div *ngSwitchCase="'stream'">
		<fa-icon icon="video" [ngStyle]="{ color: color ? color : '#aaaaaa' }"></fa-icon>
	</div>
	<div *ngSwitchCase="'police_report'">
		<fa-icon icon="gavel" [ngStyle]="{ color: color ? color : '#aaaaaa' }"></fa-icon>
	</div>
	<div *ngSwitchDefault>
		<fa-icon icon="file-alt" [ngStyle]="{ color: color ? color : '#aaaaaa' }"></fa-icon>
	</div>
</div>
